(function(){
  /**
   * Component for showing AST completion for a student.
   *
   * This component shows all levels, domains, clusters and standards.  One level is displayed at a time, selectable by
   * user.
   */
  angular.module('edxComponents')
    .component('edxStudentStandardsCompletion', {
      templateUrl: '/resources/components/standards-completion/student-standards-completion.component/student-standards-completion.component.html',
      controller: [StudentStandardsCompletionController],
      controllerAs: 'vm',
      bindings: {
        districtId: '<edxDistrictId',
        userId: '<edxUserId',
        astName: '<edxAstName',
        hideAf: '<edxHideAfButtons'
      }
    });

  function StudentStandardsCompletionController() {
    var vm = this;

    vm.onLevelSelect = onLevelSelect;

    function onLevelSelect(levelCode) {
      vm.levelCode = levelCode;
    }

  }
})();